










import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'
import { GroupBuyingComponents } from '@/views/group_buying/components'

export default defineClassComponent(
  {
    components: GroupBuyingComponents,
  },
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      // 倒计时结束
      handleCountdownEnd = () => {
        this.goodsData.value.refreshMarketing()
      }
    },
)
